// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchTypeSelect-module__wrapper___ZW05O"};